<div class="tis-snackbar-wrap">

  <!-- Icon bubble -->
  <div class="tis-snackbar-icon" [ngClass]="'tis-snackbar-icon--' + (data.type ?? 'info')">
    <span class="material-symbols-outlined">{{ icon }}</span>
  </div>

  <!-- Title + message -->
  <div class="tis-snackbar-text" [class.tis-snackbar-text--with-title]="!!data.title">
    @if (data.title) {
      <div class="tis-snackbar-title">{{ data.title }}</div>
    }
    <div class="tis-snackbar-message">{{ data.message }}</div>
  </div>

  <!-- Action button (optional) + dismiss -->
  <div class="tis-snackbar-actions">
    @if (data.actionLabel) {
      <button mat-stroked-button class="tis-bg-light" (click)="onAction()">
        {{ data.actionLabel }}
      </button>
    }
    <button type="button" class="tis-snackbar-close" (click)="onCancel()" aria-label="Dismiss">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
